import { HubConnection } from '@microsoft/signalr';
import { RouterState } from 'connected-react-router';
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

export interface Product {
    description: string;
    id: number;
    name: string;
    price: number;
    productCategoryID: number;
    productVarieties: {
        name: string;
        isDefault: boolean;
        id: number;
        price: null;
    }[];
    storeID: number;
}

export enum FinalizeOrderType {
    NotAvailable,
    PrepareOrder,
    DeliverOrder,
    PayOrder,
    PayTable
}

export interface OrderItem {
    comments: string;
    deliveredAt: string;
    dispatchedAt: string;
    id: number;
    paidAt: string;
    preparedAt: string;
    price: number;
    productID: number;
    productVarietyID: number;
    quantity: number;
    registeredAt: string;
}

export interface Order {
    completedAt: string;
    id: number;
    registeredAt: string;
    storeID: number;
    tableID: number;
    orderItems: OrderItem[];
}

export interface Table {
    code: string;
    description: string;
    allowedPeople: number;
    id: number;
    occupied: boolean;
}

export interface User {
    accessFailedCount: number;
    concurrencyStamp: any;
    email: string;
    emailConfirmed: string;
    fullName: string;
    id: number;
    lockoutEnabled: boolean;
    lockoutEnd: boolean;
    normalizedEmail: boolean;
    normalizedUserName: boolean;
    passwordHash: string;
    phoneNumber: string;
    phoneNumberConfirmed: boolean;
    securityStamp: string;
    store: string;
    storeID: number;
    twoFactorEnabled: boolean;
    userName: string;
}

export enum EventTypeTranslation {
    REQUEST_PERSONEL = 'Κληση υπαλλήλου',
    REQUEST_CASH_PAYOUT = 'Πληρωμή με μετρητά',
    REQUEST_CREDIT_CARD_PAYOUT = 'Πληρωμή με κάρτα'
}

export enum TableEventType {
    REQUEST_PERSONEL = 1,
    REQUEST_CASH_PAYOUT = 2,
    REQUEST_CREDIT_CARD_PAYOUT = 3
}

export interface TableEvent {
    comments: string;
    completedAt: string;
    createdAt: string;
    eventType: TableEventType;
    id: number;
    seenAt: string;
    storeID: number;
    tableID: number;
    totalPriceToBePaid: number;
}

export interface WorkingHours {
    id: number;
    openingDateTime: string;
    closingDateTime: string;
}

export interface INotification {
    message: SnackbarMessage;
    options: OptionsObject;
    key: SnackbarKey;
}

export interface AppStore {
    openOrders: Order[];
    products: Product[];
    tables: Table[];
    user: User;
    tableEvents: TableEvent[];
    notDispatchedOrders: Order[];
    workingHours: WorkingHours[];
    selectedTableOrder: Order;
    notifications: INotification[];
    connection: HubConnection;
}

export interface Store {
    router?: RouterState;
    app: AppStore;
}

export enum SignalRResponseMethod {
    ORDER_UPDATE = 'OrderUpdate'
}

export enum SignalRResponseAction {
    NEW_ORDER = 1,
    ORDER_IS_PREPARED = 2,
    ORDER_IS_DELIVERED = 3,
    ORDER_IS_PAID = 4,
    TABLE_IS_PAID = 5,
    NEW_TABLE_EVENT = 20,
    TABLE_EVENT_IS_SEEN = 21
}

export interface SignalRResponse {
    action: SignalRResponseAction;
    entity: any;
    method: SignalRResponseMethod;
    simpleID: number;
    user: string;
}

export enum WorkingHoursType {
    OPEN_EARLY = 1,
    STAY_OPEN_LATE = 2,
    CLOSE_STORE = 3
}

export enum ReservationStatus {
    USER_NOT_VERIFIED = 1,
    USER_VERIFIED = 2,
    STORE_CONFIRMED = 3,
    RESERVATION_SHOWN = 10,
    RESERVATION_NOT_SHOWN = 11
}

export type Reservation = {
    date: string;
    email: string;
    numberOfPersons: number;
    name: string;
    comment: string;
    phoneNumber: any;
    verifiedAt: string;
    storeConfirmedAt: string;
    status: ReservationStatus;
    id: number;
};
